import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipsComponent } from './chips.component';
import { ChipModule } from 'primeng/chip';
import { InputModule } from '../input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorModule } from '../form-error';

@NgModule({
  declarations: [ChipsComponent],
  imports: [CommonModule, ChipModule, InputModule, FormsModule, FormErrorModule, ReactiveFormsModule],
  exports: [ChipsComponent],
})
export class ChipsModule {}
